"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _pipe = _interopRequireDefault(require("lodash/fp/pipe"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

var putBgColor = function putBgColor(bgColor) {
  return function (style) {
    return bgColor ? (0, _extends2.default)({}, style, {
      backgroundColor: bgColor
    }) : style;
  };
};

var putSize = function putSize(size, fontSize) {
  return function (style) {
    var numSize = (typeof size === 'string' ? {
      small: 24,
      large: 56,
      normal: null
    }[size] || null : size) || null;
    return numSize ? (0, _extends2.default)({}, style, {
      width: numSize,
      height: numSize,
      fontSize: fontSize === 'auto' ? "".concat(numSize * 1.25 / 40, "rem") : fontSize
    }) : (0, _extends2.default)({}, style, fontSize === 'auto' ? {} : {
      fontSize: fontSize
    });
  };
};

var putMargin = function putMargin(margin) {
  return function (style) {
    return (0, _extends2.default)({}, style, {
      margin: {
        none: 0,
        dense: 4,
        normal: 8
      }[margin] || 0
    });
  };
};
/**
 * AvatarPreview zobrazuje iconu avatara. Pokud neni k dispozici avatar img, tak se misto toho zobrazi placeholder.
 *
 * @component
 */


var AvatarPreview = function AvatarPreview(_ref) {
  var bgColor = _ref.bgColor,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 'auto' : _ref$fontSize,
      icon = _ref.icon,
      imageSrc = _ref.imageSrc,
      label = _ref.label,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 'normal' : _ref$margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      style = _ref.style,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["bgColor", "children", "fontSize", "icon", "imageSrc", "label", "margin", "size", "style"]);

  var iconFontSize = _react.default.useMemo(function () {
    return (0, _cond.default)([[function (fs) {
      return fs === 'auto';
    }, function () {
      return undefined;
    }], [function (fs) {
      return !!fs;
    }, function (fs) {
      return fs;
    }], [function () {
      return true;
    }, function () {
      return size === 'normal' ? 'default' : size;
    }]])(fontSize);
  }, [fontSize, size]);

  var finalStyle = (0, _pipe.default)(putBgColor(bgColor), putSize(size, fontSize), putMargin(margin))(style || {});
  var avatarProps = (0, _cond.default)([[function (x) {
    return !!x.imageSrc;
  }, function (x) {
    return {
      alt: x.label,
      src: x.imageSrc,
      children: null
    };
  }], [function (x) {
    return !!x.icon;
  }, function (x) {
    return {
      children: /*#__PURE__*/_react.default.cloneElement(x.icon, {
        fontSize: iconFontSize
      })
    };
  }], [function () {
    return true;
  }, function (x) {
    return {
      children: children || x.label
    };
  }]])({
    imageSrc: imageSrc,
    icon: icon,
    label: label
  });
  return /*#__PURE__*/_react.default.createElement(_Avatar.default, (0, _extends2.default)({}, rest, {
    style: finalStyle
  }, avatarProps));
};

process.env.NODE_ENV !== "production" ? AvatarPreview.propTypes = {
  /**
     * Barva pozadi.
     */
  bgColor: _propTypes.default.string,

  /**
     * Obsah. Pouzije se v pripade, ze nejsou definovany props `icon` a `imageSrc`. Ma prednost pred `label`.
     */
  children: _propTypes.default.node,

  /**
     * Velikost fontu v px, nebo 'auto' pro vypocet velikosti z velikosti avataru (`size`), neho 'inherit' pro
     * prevzeti velikosti z parent definice.
     */
  fontSize: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.oneOf(['inherit']), _propTypes.default.number]),

  /**
     * Element icony. Ked ma hodnotu bude pouzite ako obsah.
     */
  icon: _propTypes.default.element,

  /**
     * Cesta k zobrazovanemu obrazku. V pouziti ma prednost pred `icon` a `children`.
     */
  imageSrc: _propTypes.default.string,

  /**
     * Obsah zobrazovany v ramci avataru v pripade, ze nedi definovan `imageSrc` nebo icon.
     * Pro `imageSrc je pouzit jako `alt`.
     */
  label: _propTypes.default.node,
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
     * Velikost avataru. Muze byt jedena z variant odpovidajici velikostem
     *
     * - 'small' 32px
     * - 'normal' 40px
     * - 'large' 56px
     *
     * nebo vlatni velikost v px.
     */
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['normal']), _propTypes.default.oneOf(['small']), _propTypes.default.oneOf(['large']), _propTypes.default.number])
} : void 0;
AvatarPreview.displayName = 'AvatarPreview';

var _default = (0, _withThemeProps.default)({
  name: 'SxAvatarPreview'
})(AvatarPreview);

exports.default = _default;